import { FieldItem } from "./studio";
import type { BlockDefinition, UserAccountsDefinition } from "./types";
import { countDuplicateControlKeys } from "./utils";

const logError = (message: string) => {
    // @TODO: separate out typechecking for different projects
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore our typechecking script can't pick up d.ts files from individual projects
    if (import.meta.env.MODE === "test") return;
    console.error(`[Block definition violation] ${message}`);
};

const isFieldItem = (maybeFieldItem: unknown): maybeFieldItem is FieldItem => {
    return (
        maybeFieldItem !== null &&
        maybeFieldItem !== undefined &&
        typeof maybeFieldItem === "object" &&
        "field" in maybeFieldItem
    );
};

export const validateNoDuplicateControlKeys = (definition: BlockDefinition | UserAccountsDefinition) => {
    const blockStyles = definition?.elements?.container?.styles;
    if (blockStyles) {
        const duplicateBlockControlKeys = countDuplicateControlKeys(blockStyles);
        if (duplicateBlockControlKeys.length) {
            duplicateBlockControlKeys.forEach(([key]) =>
                logError(`Control with key "${key}" appears more than once in block styles`),
            );
            throw new Error("You cannot have duplicate control keys in block styles");
        }
    }

    if (definition?.elements?.definitions) {
        Object.values(definition.elements.definitions)
            .filter(isFieldItem)
            .forEach((fieldItem) => {
                const duplicateFieldItemControlKeys = countDuplicateControlKeys(fieldItem.styles || []);
                if (duplicateFieldItemControlKeys.length) {
                    duplicateFieldItemControlKeys.forEach(([key]) =>
                        logError(
                            `Control with key "${key}" appears more than once in field item "${fieldItem.field.type}" styles`,
                        ),
                    );
                    throw new Error(
                        `You cannot have duplicate control keys in field "${fieldItem.field.type}" item styles`,
                    );
                }
            });
    }
};

export const validateBlockDefinition = (definition: BlockDefinition | UserAccountsDefinition) => {
    validateNoDuplicateControlKeys(definition);
};
